import { useParams } from 'react-router-dom';

export const useArtifactStorageId = () => {
  const { fileId } = useParams<Dictionary<string>>();

  return fileId;
};
